<template>
  <div class="sac-check-container">
    <div class="sac-check-row">
      <input
        :id="`${field}-check`"
        type="checkbox"
        class="sac-check"
        :checked="checked"
        :disabled="disable"
        @change="change(field, !checked)"
      >
      <label
        :for="`${field}-check`"
        class="sac-check-label"
      >
        {{ label }}
      </label>
    </div>
    <div
      v-if="subLabel"
      class="sac-check-row"
    >
      <div class="sac-check-sub-label">
        {{ subLabel }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SACCheck',
  props: {
    field: String,
    checked: Boolean,
    change: Function,
    label: String,
    subLabel: String,
    disable: Boolean,
  },
};
</script>

<style lang="scss">

.sac-check-container {
  display: grid;
  justify-content: flex-start;
  align-items: center;
  .sac-check-row {
    display: grid;
    grid-auto-flow: column;
    grid-template-columns: 20px 1fr;
    align-items: center;
  }
  .sac-check {
    transform: scale(1.5);
    cursor: pointer;
  }
  .sac-check-label {
    margin-left: 8px;
    font-size: 1rem;
    font-weight: 600;
    color: $N70;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
  .sac-check-sub-label {
    grid-column: 2;
    margin-left: 8px;
    font-size: 1rem;
    font-weight: 500;
    color: $N60;
    max-width: 600px;
  }
}
</style>
